import { createContext } from 'react';
import { getFeatureFlags, type FeatureFlags } from '@a1/shared';
import { aiFeaturesEnabled } from 'constants-ts/featureFlags';

// Default to all flags off so consumers outside the provider fail safely.
const FeatureFlagsContext = createContext<FeatureFlags>(getFeatureFlags(null, { aiFeaturesEnabled }));

export default FeatureFlagsContext;
